module.exports = __webpack_public_path__ + "img/read-img5.961a74db.png";